import React from "react"
import NebLogo from "../images/logo.png"

import defStyles from "@modules/style.module.css"

export default function Logo({ siteTitle }) {
  return (
      <img className={defStyles.topLogo} src={NebLogo} alt="Nebula logo" />
  )
}
